import IconImageComponent from 'components/IconImageComponent';
import intelbras_logo from '../../../assets/images/icons/devices/intelbras_logo.webp';
import controlId_logo from '../../../assets/images/icons/devices/controlId_logo.webp';
import hikvision_logo from '../../../assets/images/icons/devices/hikvision_logo.webp';
import topdata_logo from '../../../assets/images/icons/devices/topdata_logo.svg';

export type BrandTypes = 'INTELBRAS' | 'CONTROLID' | 'HIKVISION' | 'TOPDATA';

interface BrandIconsProps {
  brand: BrandTypes;
}

const BrandIcons = ({ brand }: BrandIconsProps) => {
  switch (brand) {
    case 'CONTROLID':
      return <IconImageComponent src={controlId_logo} width={50} height={20} />;
    case 'INTELBRAS':
      return <IconImageComponent src={intelbras_logo} width={60} height={18} />;
    case 'HIKVISION':
      return <IconImageComponent src={hikvision_logo} width={50} height={20} />;
    case 'TOPDATA':
      return <IconImageComponent src={topdata_logo} width={55} height={18} />;
    default:
      return <>{brand}</>;
  }
};

export default BrandIcons;
